export const locale = {
  lang: 'fr',
  data: {
    memberBills: {
      list: {
        billDate: 'Date de la facture',
        paymentDate: 'Date de paiement',
        memberBillCode: 'No de facture',
        amount: 'Montant',
        isCanceled: 'Facture annulée',
        batchCode: 'No du lôt',
        item: 'Article',
        quantity: 'Quantité',
        total: 'Grand total',
        payedAmount: 'Montant payé',
        origin: 'Origine',
        billType: 'Type de facture',
        billTypeLegalEntity: 'Exercice en société',
        billTypeMemberTableau: 'Tableau des membres',
        source: 'Provenance',
        legalEntityName: 'Société',
      },
      actions:{
        showBill:'Afficher la facture',
        payInvoice:'Payer la facture'
      },
      report:{
        title:'Facture',
        loadErrorTitle: 'Facture',
        loadError: 'Impossible d\'ouvrir la facture. Veuillez réessayer plus tard.'
      },
      invoicePayment:{
        title:'Paiement de la facture',
        amountToPay:'Montant à payer',
        nameUnderCard:'Nom sur la carte bancaire',
        reassuranceMessage:'Veuillez vous assurer que le montant et le nom sous la carte sont corrects avant de procéder au paiement.',
        paymentSuccessful: 'Paiement réussi',
        transactionId: 'ID de transaction',
        date: 'Date',
        amount: 'Montant',
        cardType: 'Type de carte',
        cardNumber: 'Numéro de carte',
        authorization: 'Numéro d\'autorisation',
        thankYou: 'Merci pour votre paiement. Votre facture a été traitée avec succès.',
        total: 'Total',
        billLines: 'Lignes de facture',
        errors: {
          noBillsFound: 'Aucune facture trouvée pour le paiement',
          inscriptionBillNotPayable: 'Cette facture d\'inscription ne peut pas être payée ici. Veuillez utiliser le processus d\'inscription annuelle.',
          sumOrMonerisError: 'Une erreur est survenue lors du traitement du paiement',
          transactionError: 'Transaction refusée par l\'émetteur de la carte',
          paymentError: 'Une erreur est survenue lors du traitement du paiement. Veuillez réessayer.'
        }
      }
    },
    list: {
      noData: 'Pas de données',
    }
  }
}